import { fetchJSON } from "./utils";

// needs to send the access_token, jwt for site in the cookies
export function getAuthTokensForAcServer(org_id) {
  const url = "/api/messenger/auth/token";
  return fetchJSON(url, {org_id: org_id}, null, "get");
}

// gets post presginedUrls for s3 for attachments
export async function createPostPresignedUrls(data) {
  const url = "/api/messenger/attachments";
  return fetchJSON(url, null, data, "post");
}
